import request from '@/utils/request'

export function updateExceptionConfig(data) {
  return request({
    url: 'api/v1/exception-config/updateList',
    method: 'post',
    data: data
  })
}

export function getExceptionConfigList(data) {
  return request({
    url: 'api/v1/exception-config/getList',
    method: 'post',
    data: data
  })
}

export function delExceptionConfigCfg(data) {
  return request({
    url: 'api/v1/exception-config/delList',
    method: 'delete',
    data: data
  })
}

export function getExceptionUserList(data) {
  return request({
    url: 'api/v1/exception-config/getUserList',
    method: 'post',
    data: data
  })
}

export function retroactiveAwards(data) {
  return request({
    url: 'api/v1/exception-config/retroactiveAwards',
    method: 'post',
    data: data
  })
}

